import { render, staticRenderFns } from "./billingaccount.vue?vue&type=template&id=310a2e56&"
import script from "./billingaccount.vue?vue&type=script&lang=js&"
export * from "./billingaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports